// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowListModal-cls1_LpD","cls2":"BulkFollowListModal-cls2_tZS BulkFollowListModal-cls1_LpD"};